/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Surcharge
 */
export interface Surcharge {
    /**
     * The amount in euro
     * @type {number}
     * @memberof Surcharge
     */
    amount?: number;
    /**
     * The surcharge code
     * @type {string}
     * @memberof Surcharge
     */
    code?: string;
    /**
     * The surcharge name
     * @type {string}
     * @memberof Surcharge
     */
    name?: string;
}

/**
 * Check if a given object implements the Surcharge interface.
 */
export function instanceOfSurcharge(value: object): value is Surcharge {
    return true;
}

export function SurchargeFromJSON(json: any): Surcharge {
    return SurchargeFromJSONTyped(json, false);
}

export function SurchargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Surcharge {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function SurchargeToJSON(json: any): Surcharge {
    return SurchargeToJSONTyped(json, false);
}

export function SurchargeToJSONTyped(value?: Surcharge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'code': value['code'],
        'name': value['name'],
    };
}

